import { render } from "./EmbeddedComponents.vue?vue&type=template&id=2321714e"
import script from "./EmbeddedComponents.vue?vue&type=script&lang=js"
export * from "./EmbeddedComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__